import Markdown from "markdown-to-jsx";
import React, { type FC } from "react";
import { useTranslation } from "react-i18next";
import type { NestTestResultError } from "src/api/interfaces/nest/history";
import "./index.css";
import { KatFlashbar } from "@amzn/katal-react";
import MarkdownExpandableText from "src/components/MarkdownExpandableText/MarkdownExpandableText";

interface NestErrorDetailContentProps {
  content: NestTestResultError;
}

const NestErrorDetailContent: FC<NestErrorDetailContentProps> = ({
  content,
}) => {
  const { t } = useTranslation();

  return (
    <div className="nest-error-detail-content">
      {content.element && (
        <div className="nest-error-detail-item nest-error-detail-item--full">
          <h6>{t("aic_nest_history_error_element")}</h6>
          <p>{content.element}</p>
        </div>
      )}
      {content.detailedMessage && (
        <div className="nest-error-detail-item">
          <h6>{t("aic_nest_history_error_detailedMessage")}</h6>
          <Markdown>
            {t(content.detailedMessage.key, content.detailedMessage.parameters)}
          </Markdown>
        </div>
      )}
      {content.solutionPath && (
        <div className="nest-error-detail-item">
          <h6>{t("aic_nest_history_error_solutionPath")}</h6>
          <MarkdownExpandableText
            content={{
              details: t(
                content.solutionPath.key,
                content.solutionPath.parameters
              ),
            }}
          />
        </div>
      )}

      {(content.examples?.length ?? 0) > 0 && (
        <KatFlashbar
          variant="warning"
          header={t("aic_nest_history_reference_content")}
          description={t("aic_nest_history_reference_content_examples", {
            values: content.examples?.join(", "),
          })}
          linkTarget="_blank"
          linkHref={content.resources?.at(0)}
          linkLabel={
            content.resources?.at(0) &&
            t("aic_nest_history_reference_content_link")
          }
        />
      )}
    </div>
  );
};

export default NestErrorDetailContent;
